/* eslint-disable @typescript-eslint/naming-convention */
export interface JobDropdown {
  Id: string;
  JobID: string;
  CompanyID: number;
  CompanyGUID: string;
  IsActive: boolean;
  IsUserFavorite: boolean;
  Name: string;
  OverflowSTLimit: number;
  OverflowOTLimit: number;
  OverflowRules: string;
  ManPowerReqID: string;
  MappingPlatform?: string;
  CraftTemplate?: number;
  ParentFacilityID?: number;
  VPParentFacilityKeyID?: number;
  ProjectManagerHRRef?: number;
  /** Foreman-created job not yet linked to Viewpoint (job dropdown). */
  isTemporaryForemanJob?: boolean;
}
